import { FormInputDropdown } from '@AMIEWEB/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import { GridCellParams } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectEditPreferenceChildrenRows,
  selectIsEditMod,
  selectPreferenceChildrenGenderError,
} from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { findIndex, findRow } from '../AdultGridComponents/AdultNameCell';
import { getDisplayValue } from '../utils';

interface GridCellProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export const ChildrenGenderCell = (cellParams: GridCellParams) => {
  return <ChildrenGender cellParams={cellParams} />;
};

const ChildrenGender = React.memo(function ChildrenGender(cellParams: GridCellProps) {
  const dispatch = useDispatch();
  const { control } = useFormContext();

  const isModEdit = useSelector(selectIsEditMod);
  const editPreferenceChildrenRequests = useSelector(selectEditPreferenceChildrenRows);
  const PreferenceChildrenGenderError = useSelector(selectPreferenceChildrenGenderError);

  const RowId = cellParams?.cellParams?.id;
  const rowData = getDisplayValue(RowId, editPreferenceChildrenRequests);
  const gender = rowData?.gender;
  const [childrenGender, setChildrenGender] = useState(gender === '--' ? null : gender);

  const options = [
    {
      ID: 1,
      Description: 'Female',
    },
    {
      ID: 2,
      Description: 'Male',
    },
  ];

  const setChildrenGenderEdit = data => {
    setChildrenGender(data);
    let newRows = editPreferenceChildrenRequests.slice(0);
    let childrenGridEditRow = findRow(editPreferenceChildrenRequests, RowId);

    let updateGender = {
      ...childrenGridEditRow,
      gender: data,
    };

    let editGenderIndex = findIndex(editPreferenceChildrenRequests, RowId);

    newRows[editGenderIndex] = updateGender;
    dispatch(placementModsAction.setEditChildrenRows(newRows));
  };

  //UPDATE THE ERROR
  useEffect(() => {
    if (cellParams?.cellParams?.error !== null && cellParams?.cellParams?.error !== undefined) {
      const val = PreferenceChildrenGenderError?.filter(el => el.id === cellParams?.cellParams?.id);

      if (val?.length === 0) {
        const arr = PreferenceChildrenGenderError?.length > 0 ? PreferenceChildrenGenderError.slice(0) : [];
        const valueObj = { gender: cellParams?.cellParams?.error, id: cellParams?.cellParams?.id };

        arr.push(valueObj);

        dispatch(placementModsAction.setPreferenceChildrenGenderError(arr));
      } else {
        const arr = PreferenceChildrenGenderError?.slice(0);
        let currentObj = arr.find(v => v.id === cellParams?.cellParams?.id);

        let updatedObj = { ...currentObj, gender: cellParams?.cellParams?.error };

        let editIndex = arr.findIndex(v => v.id === cellParams?.cellParams?.id);
        arr[editIndex] = updatedObj;

        dispatch(placementModsAction.setPreferenceChildrenGenderError(arr));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cellParams?.cellParams?.error]);

  return (
    <>
      <Controller
        name={`childrenGrid${RowId}.gender`}
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, ...rest } }) => (
          <FormInputDropdown
            name={'childrenGrid.Gender'}
            require={true}
            standard={true}
            options={options ?? []}
            inputValue={childrenGender ?? null}
            readOnly={!isModEdit}
            handleChange={e => setChildrenGenderEdit(e.target.value)}
          ></FormInputDropdown>
        )}
      />
    </>
  );
});
